// The Lender mark, used only when a build carries no tenant logo of its own.
export const BRAND_LOGO_FALLBACK_SRC = '/assets/images/logos/lender_icon.svg';

const getIsDarkAppearance = () =>
  window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;

// The tenant's logo, inlined at build time as window.lsBrandLogo for the screens that paint BEFORE
// React mounts and before /api/tenant resolves (DEV-3717). Every one of those screens must resolve
// the logo through here: a white-label app that falls back to the Lender mark while it has a brand
// of its own is showing the vendor's identity inside the client's app.
//
// The boot splash follows the OS appearance (DEV-5561), and a light lockup is dark lettering that
// disappears on a dark splash — so prefer the brand's dark-appearance mark when it ships one. Brands
// with a single-appearance mark are unaffected: lsBrandLogoDark is only inlined when it exists.
export const getBrandLogoSrc = () => {
  const darkLogo = getIsDarkAppearance() ? window.lsBrandLogoDark : null;

  return darkLogo || window.lsBrandLogo || BRAND_LOGO_FALLBACK_SRC;
};
